'use strict';

angular.module('app.commonPageDetail', [])
    .controller('commonPageDetailCtrl', ['$scope', '$modal', 'commonPagesService', 'commonPageDetailService',
        function ($scope, $modal, commonPagesService, commonPageDetailService) {

            $scope.preLoadData = function(){
                $scope.subfix = $scope.index.subfix;
                $scope.setting = $scope.index.setting.description;
                $scope.renderSetting();
            }

            $scope.renderSetting = function(){
                commonPagesService.getCommonPagesSetting(false)
                .then(function(response) {
                    $scope.settings = response.data;
                    $scope.settings.forEach(function (val){
                        if($scope.index.setting != null){
                            if(val.id == $scope.index.setting.id){
                                val.ticked = true;
                                $scope.outputSetting = val;
                            }
                        }
                    })
                }, function(response) {
                    var errorModalInstance = $modal.open({
                        scope: $scope,
                        templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                        windowClass: 'modal-dialog-mention-error'
                    });
                    $scope.errorModalInstance = errorModalInstance;
                    $scope.errorMessage = response.message;
                })
            }

            $scope.preLoadData();
            
            $scope.updateCommonPage = function () {
                $scope.selectedSetting = "";
                $scope.settings.forEach(function (val) {
                    if (val.ticked === true) {
                        $scope.selectedSetting = val.id;
                    }    
                });

                var params = {
                    id: $scope.index.id,
                    subfix: $scope.subfix,
                    setting: $scope.selectedSetting
                }

                commonPageDetailService.updateCommonPage(params, true) 
                    .then(function(response){
                        $scope.modalInstance.close(function () {
                            $log.info('Close Modal now');
                        })

                        location.reload('admin/commonPages');
                    }, function(response){
                        var errorModalInstance = $modal.open({
                            scope: $scope,
                            templateUrl: 'app/common/partials/errorMessageBox.html?app_v=deployDate',
                            windowClass: 'modal-dialog-mention-error'
                        });
                        $scope.errorModalInstance = errorModalInstance;
                        $scope.errorMessage = response.message;
                    })
            }

            $scope.deleteCommonPage = function () {
                var modalInstance = $modal.open({
                    scope: $scope,
                    templateUrl: 'app/admin/commonPages/commonPageDetail/deleteCommonPage/deleteCommonPage.html?app_v=deployDate',
                    controller: 'deleteCommonPageCtrl', 
                });

                $scope.modalInstance = modalInstance;
            }  
}])